import * as React from "react";
import { Redirect } from "react-router-dom";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button, Input} from 'reactstrap';

import { Wrapper, Content, ContentCol , ContentRow, ContentRowSingleCol, InputWrapper} from './CourseLesson.styles';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class CourseLesson extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.updateInfo = this.updateInfo.bind(this);
        this.handleChange =  this.handleChange.bind(this);
    }

    public onGoBack() {
        const { history } = this.props;
        // history.goBack();
        // window.history.back();
        const dest = this.props.services.currentBaseUrl + 'courses/' + this.state.data.courseLesson.Course;
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: courseLessonID } } = match;

        const courseInfoRes = await adminAPI.getSingleItemGeneral('course_lessons', courseLessonID);
    
        if (courseInfoRes.ok) {
            
            const courseLesson = courseInfoRes.data;
            console.log("Details: " + JSON.stringify(courseLesson, null, 2))

            this.setState(
                {
                     data: {
                        courseLesson
                     }
                }
            )
        } else {
            toast.error('Error fetching course details!');
        }
    }

    public handleChange(id, e) {
        console.log(e)
        const data = this.state.data
        data.courseLesson[id] = e.target.value;
        this.setState({
            data
        });
    }

    public async updateInfo() {
        this.setState({
            loaded: false
        });

        const item = this.state.data.courseLesson;

        const res = await this.props.services.adminAPI.updateItemGeneral('course_lessons', item, item.CourseLessonId);

        if (res.ok) {
            toast.success('Update Successful');
        }
        else {
            toast.error('Update Failed')
        }

        this.setState({
            loaded: true
         });
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>
              <Content>
                <ContentRow>

                    <ContentCol>
                        <div>
                            <label htmlFor="title" style={{ display: 'block' }}>
                                Title
                            </label>
                            {/*tslint:disable-next-line jsx-no-lambda*/}
                            <textarea rows={6} cols={38} id="title" value={data.courseLesson.Name} onChange= {(e) => this.handleChange('Name', e)}/>
                        </div>
                    
                    </ContentCol>

                    <ContentCol>
                        <div>
                            <label htmlFor="description" style={{ display: 'block' }}>
                                Description
                            </label>
                            {/*tslint:disable-next-line jsx-no-lambda*/}
                            <textarea rows={6} cols={38} id="description" value={data.courseLesson.Description} onChange= {(e) => this.handleChange('Description', e)}/>
                        </div>
                    
                    </ContentCol>

                </ContentRow>
              </Content>
              <Content>
                <ContentRowSingleCol>
                  <div>
                    <Button onClick={this.updateInfo}>
                      Update
                    </Button>
                  </div>
                </ContentRowSingleCol>
              </Content>
            </Wrapper>    
        );
    
    }

}

export default withServices(CourseLesson);


// WEBPACK FOOTER //
// ./src/pages/Admin/Courses/CourseLesson/CourseLesson.tsx